<template>
  <div
    class="p-4 md:p-6 lg:p-8 xl:p-10 bg-app-bg-light dark:bg-app-bg-dark min-h-screen"
  >
    <div class="mb-8">
      <h1 class="text-3xl font-bold text-slate-800 dark:text-slate-100 mb-2">
        Panel de Caja
      </h1>
      <p class="text-slate-600 dark:text-slate-400">
        Control de pagos - {{ fechaActual }}
      </p>
    </div>

    <!-- Filtro de Turno -->
    <div
      class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-5 shadow-sm mb-8"
    >
      <h2
        class="text-base font-semibold text-slate-700 dark:text-slate-200 mb-3 flex items-center gap-2"
      >
        <i class="bx bx-filter-alt text-custom-primary"></i> Filtro de Turno
      </h2>
      <div class="flex flex-wrap gap-4 items-end">
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Desde</label
          >
          <input
            type="datetime-local"
            v-model="filtro.fechaInicio"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Hasta</label
          >
          <input
            type="datetime-local"
            v-model="filtro.fechaFin"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <button
          @click="cargarTodo"
          class="bg-custom-primary hover:opacity-90 text-white px-4 py-2 rounded-lg text-sm font-medium transition-opacity border-0"
        >
          <i class="bx bx-refresh mr-1"></i>Actualizar
        </button>
      </div>
    </div>

    <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm mb-8">
      <h2 class="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-6">
        Acciones Rápidas
      </h2>
      <div class="flex justify-center">
        <button
          @click="$router.push('/cuentas-pendientes-mesas')"
          class="flex flex-col items-center p-6 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 shadow-md hover:shadow-lg transition-all group border-0"
        >
          <i
            class="bx bx-receipt text-5xl text-custom-primary mb-3 group-hover:scale-110 transition-transform"
          ></i>
          <span class="text-lg font-medium text-slate-700 dark:text-slate-300"
            >Cobrar Cuentas de Restaurante</span
          >
        </button>
      </div>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <div
          class="p-3 bg-green-100 dark:bg-green-900/30 rounded-lg w-fit mb-3"
        >
          <i
            class="bx bx-dollar-circle text-3xl text-green-600 dark:text-green-400"
          ></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100">
          Q{{ stats.ingresosDia }}
        </h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">
          Ingresos del Día
        </p>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <div
          class="p-3 bg-yellow-100 dark:bg-yellow-900/30 rounded-lg w-fit mb-3"
        >
          <i
            class="bx bx-receipt text-3xl text-yellow-600 dark:text-yellow-400"
          ></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100">
          {{ stats.cuentasPendientes }}
        </h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">
          Cuentas Pendientes
        </p>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <div class="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-lg w-fit mb-3">
          <i
            class="bx bx-credit-card text-3xl text-blue-600 dark:text-blue-400"
          ></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100">
          {{ stats.transacciones }}
        </h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">Transacciones</p>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <div
          class="p-3 bg-purple-100 dark:bg-purple-900/30 rounded-lg w-fit mb-3"
        >
          <i
            class="bx bx-wallet text-3xl text-purple-600 dark:text-purple-400"
          ></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100">
          Q{{ stats.efectivo }}
        </h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">
          Efectivo en Caja
        </p>
      </div>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <h2
          class="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-6"
        >
          Métodos de Pago Hoy
        </h2>
        <div class="space-y-4">
          <div
            class="flex items-center justify-between p-3 rounded-lg bg-slate-50 dark:bg-slate-700/50"
          >
            <div class="flex items-center gap-3">
              <i
                class="bx bx-money text-2xl text-green-600 dark:text-green-400"
              ></i>
              <span class="text-slate-700 dark:text-slate-300">Efectivo</span>
            </div>
            <span class="font-bold text-slate-800 dark:text-slate-100"
              >Q{{ metodosPago.efectivo }}</span
            >
          </div>
          <div
            class="flex items-center justify-between p-3 rounded-lg bg-slate-50 dark:bg-slate-700/50"
          >
            <div class="flex items-center gap-3">
              <i
                class="bx bx-credit-card text-2xl text-blue-600 dark:text-blue-400"
              ></i>
              <span class="text-slate-700 dark:text-slate-300">Tarjeta</span>
            </div>
            <span class="font-bold text-slate-800 dark:text-slate-100"
              >Q{{ metodosPago.tarjeta }}</span
            >
          </div>
          <div
            class="flex items-center justify-between p-3 rounded-lg bg-slate-50 dark:bg-slate-700/50"
          >
            <div class="flex items-center gap-3">
              <i
                class="bx bx-transfer text-2xl text-purple-600 dark:text-purple-400"
              ></i>
              <span class="text-slate-700 dark:text-slate-300"
                >Transferencia</span
              >
            </div>
            <span class="font-bold text-slate-800 dark:text-slate-100"
              >Q{{ metodosPago.transferencia }}</span
            >
          </div>
        </div>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <h2
          class="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-6"
        >
          Últimas Transacciones
        </h2>
        <div
          v-if="ultimasTransacciones.length === 0"
          class="text-center text-slate-500 dark:text-slate-400 py-8"
        >
          No hay transacciones registradas hoy
        </div>
        <div v-else class="space-y-3">
          <div
            v-for="trans in ultimasTransacciones"
            :key="trans.id"
            class="flex items-center justify-between p-3 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700"
          >
            <div>
              <p class="font-medium text-slate-800 dark:text-slate-100">
                {{ trans.concepto }}
              </p>
              <p class="text-xs text-slate-500 dark:text-slate-400">
                {{ trans.hora }}
              </p>
            </div>
            <span class="font-bold text-green-600 dark:text-green-400"
              >Q{{ trans.monto }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '../../config/config.js';

export default {
  name: 'DashboardCajero',
  data() {
    // Turno restaurante: 6am hoy → 11pm hoy
    const hoy = new Date();
    const inicio = new Date(hoy); inicio.setHours(6, 0, 0, 0);
    const fin = new Date(hoy); fin.setHours(23, 0, 0, 0);
    const toLocal = d => new Date(d - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
    return {
      loading: true,
      filtro: {
        fechaInicio: toLocal(inicio),
        fechaFin: toLocal(fin)
      },
      stats: { ingresosDia: 0, cuentasPendientes: 0, transacciones: 0, efectivo: 0 },
      metodosPago: { efectivo: 0, tarjeta: 0, transferencia: 0 },
      ultimasTransacciones: []
    };
  },
  computed: {
    fechaActual() {
      return new Date().toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    }
  },
  methods: {
    async cargarStats() {
      try {
        this.loading = true;
        const response = await axios.get(`${API_URL}/dashboard/cajero`, {
          params: { fecha_inicio: this.filtro.fechaInicio, fecha_fin: this.filtro.fechaFin }
        });

        this.stats.ingresosDia = response.data.ingresosDia || 0;
        this.stats.cuentasPendientes = response.data.cuentasPendientes || 0;
        this.stats.transacciones = response.data.transacciones || 0;
        this.stats.efectivo = response.data.efectivo || 0;

        this.loading = false;
      } catch (error) {
        console.error('Error cargando estadísticas:', error);
        this.loading = false;
      }
    },
    async cargarMetodosPago() {
      try {
        const response = await axios.get(`${API_URL}/dashboard/metodos-pago-dia`, {
          params: { fecha_inicio: this.filtro.fechaInicio, fecha_fin: this.filtro.fechaFin }
        });
        this.metodosPago = {
          efectivo: response.data.efectivo || 0,
          tarjeta: response.data.tarjeta || 0,
          transferencia: response.data.transferencia || 0
        };
      } catch (error) {
        console.error('Error cargando métodos de pago:', error);
      }
    },
    async cargarUltimasTransacciones() {
      try {
        const response = await axios.get(`${API_URL}/dashboard/ultimas-transacciones`, {
          params: { fecha_inicio: this.filtro.fechaInicio, fecha_fin: this.filtro.fechaFin }
        });
        this.ultimasTransacciones = response.data.map(item => ({
          id: item.id,
          concepto: item.concepto,
          hora: new Date(item.hora).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }),
          monto: parseFloat(item.monto).toFixed(2)
        }));
      } catch (error) {
        console.error('Error cargando transacciones:', error);
      }
    },
    cargarTodo() {
      this.cargarStats();
      this.cargarMetodosPago();
      this.cargarUltimasTransacciones();
    }
  },
  mounted() {
    this.cargarTodo();
  }
}
</script>
